export const coursePlayer = {
    state: {
        coursePlayer: [],
        videos: [],
        materials: [],
        userStats: [],
        currentVideo: [],
        playVideo: false,
        totalVideos: 0,
        courseCompleted: false,
        test: [],
    },
    mutations: {
        SET_CoursePlayer(state, coursePlayer) {
            state.coursePlayer = coursePlayer;
        },
        SET_Videos(state, course) {
            let watched = course.enrolled.data.watched.data.map(x => {
                return x.asset.data.id
            });
            let vids = course.videos.data.map(x => {
                x.watched = watched.includes(x.id) ? true : false;
                return x;
            });
            state.videos = vids;
        },
        SET_CoursePreviewVideos(state, course) {
            if(!course.enrolled) {
                course.enrolled = course.assets.data;
            }
            // let watched = course.enrolled.data.watched.data.map(x => {
            //     return x.asset.data.id
            // });
            let vids = course.videos.data.map(x => {
                //x.watched = watched.includes(x.id) ? true : false;
                return x;
            });
            state.videos = vids;
        },
        SET_Materials(state, materials) {
            state.materials = materials;
        },
        SET_Test(state, test) {
            state.test = test;
        },
        SET_UserStats(state, userStats) {
            state.userStats = userStats;
        },
        SET_CurrentVideo(state, currentVideo) {
            state.currentVideo = currentVideo;
        },
        SET_PlayVideo(state, playVideo) {
            state.playVideo = playVideo;
        },
        SET_TotalVideos(state, videos) {
            state.totalVideos = videos.length;
        }
    },
    actions: {
        setCoursePlayer: ({ commit, state }, course) => {
            commit('SET_CoursePlayer', course)
            commit('SET_Materials', course.documents.data)
            commit('SET_CurrentVideo', course.videos.data[0])
            commit('SET_UserStats', course.enrolled.data)
            commit('SET_Videos', course)
            commit('SET_TotalVideos', course.videos.data)

            if(course.hasOwnProperty('test')) {
                commit('SET_Test', course.test.data)
            }

            return state.coursePlayer
        },
        setCoursePreviewCoursePlayer: ({ commit, state }, course) => {
            commit('SET_CoursePlayer', course)
            commit('SET_Materials', course.documents.data)
            commit('SET_CurrentVideo', course.videos.data[0])
            //commit('SET_UserStats', course.enrolled.data)
            commit('SET_CoursePreviewVideos', course)
            commit('SET_TotalVideos', course.videos.data)

            if(course.hasOwnProperty('test')) {
                commit('SET_Test', course.test.data)
            }

            return state.coursePlayer
        },
        setMaterials: ({ commit, state }, materials) => {
            commit('SET_Materials', materials)
            return state.materials
        },
        setTest: ({ commit, state }, test) => {
            commit('SET_Test', test)
            return state.test
        },
        setVideos: ({ commit, state }, course) => {
            commit('SET_Videos', course)
            return state.videos
        },
        setUserStats: ({ commit, state }, userStats) => {
            commit('SET_UserStats', userStats)
            return state.userStats
        },
        setCurrentVideo: ({ commit, state }, currentVideo) => {
            commit('SET_CurrentVideo', currentVideo)
            return state.currentVideo
        },
        setPlayVideo: ({ commit, state }, playVideo) => {
            commit('SET_PlayVideo', playVideo)
            return state.playVideo
        },
    },
    getters: {
        coursePlayer: (state) => {
            return state.coursePlayer
        },
        videos: (state) => {
            return state.videos
        },
        materials: (state) => {
            return state.materials
        },
        userStats: (state) => {
            return state.userStats
        },
        currentVideo: (state) => {
            return state.currentVideo
        },
        totalVideos: (state) => {
            return state.totalVideos
        },
        courseCompleted: (state) => {
            return state.courseCompleted
        },
        playVideo: (state) => {
            return state.playVideo
        },
        test: (state) => {
            return state.test
        }
    }
};